export default __webpack_public_path__ + "static/media/editor-head.fe6c275f.jpg";